module.exports = __webpack_public_path__ + "img/6.cd1486cb.png";